import { ReactEasyForm, Select } from "@aeco-cloud/react-easy-form";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import { SendContext } from "../BepaalStatuut";

const Leave = () => {
  const text = useContext(TextContext);
  const send = useContext(SendContext);
  const form = useForm();

  const onSubmit: SubmitHandler<any> = (data) => {
    console.log(data);
    const result = data.leaveType.split(",")[1];
    // console.log("result from leave: ", result);
    data.result = result;
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question>
            <Label label={text.leave_leaveType_label} />
            <Select
              name="leaveType"
              options={[
                {
                  value: "1,secondaryActivityFalse",
                  label: text.leave_leaveType_1,
                },
                {
                  value: "2,secondaryActivityUndecided",
                  label: text.leave_leaveType_2,
                },
                {
                  value: "3,secondaryActivityFalse",
                  label: text.leave_leaveType_3,
                },
                {
                  value: "4,secondaryActivityUndecided",
                  label: text.leave_leaveType_4,
                },
                { value: "5,secondaryActivityTrue", label: text.leave_leaveType_5 },
              ]}
              rules={{ required: text.general_requiredQuestion }}
              muiSelectProps={{ fullWidth: true, variant: "outlined" }}
            />
          </Question>
        </Section>
      </StepBody>
      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Leave;
